module.exports = __webpack_public_path__ + "static/media/blue-loader.a3ddd1e7.svg";